import { Md5 } from 'ts-md5'
import { PayExportOptions } from '../src/types/WebPayTypes'
import { messageParam } from '../src/types/EvolutionTypes'
import http from '@sinolink/http'

/**
 * 参数加密
 */
export function signPreOrderWithMd5(param: any) {
  const secret = 'gjzq!@#$'
  let result: any = []
  let sign = ''
  Object.keys(param).forEach(key => {
    let o = { key, value: param[key] }
    result.push(o)
  })
  // 数组过滤出指定的key值
  const fileterKeys = [
    'account_name',
    'app_name',
    'subject',
    'out_trade_no',
    'total_fee',
    'pay_type',
    'passback_params',
    'trade_type',
    'timestamp'
  ]
  result = result.filter((it: any) => fileterKeys.some(key => key == it.key))
  // 首字母排序
  result = result.sort((a: any, b: any) => a.key.localeCompare(b.key))
  result.forEach((obj: any) => (sign += `${obj.key}${obj.value}`))
  sign = `${sign}${secret}`
  // console.log('加密前串', sign);
  return Md5.hashStr(sign)
}

/**
 * 校验必填项参数
 * @param params 支付方法参数
 */
export function checkPayParam(params: PayExportOptions) {
  let errMsg = {
    msg: '',
    code: 400400 // 使用者错误码
  }

  return new Promise((resolve, reject) => {
    if (!params) {
      errMsg.msg = '参数不能为空'
    }

    if (!params.out_trade_no) {
      errMsg.msg = '支付订单号不能为空'
    }

    if (
      params.pay_type === '' ||
      params.pay_type === null ||
      params.pay_type === undefined
    ) {
      errMsg.msg = '支付方式不能为空'
    }
    if (!params.subject) {
      errMsg.msg = '商品名称不能为空'
    }
    if (Number(params.total_fee) === 0 || (typeof params.total_fee == 'string' && !params.total_fee)) {
      errMsg.msg = '费用错误'
    }

    if (errMsg.msg) {
      resolve(errMsg);
    } else {
      resolve(true)
    }
  }).catch(() => {})
}

/**
 * 判断是否是微信客户端
 * @returns 是否是微信客户端
 */
export function isWeixinClient() {
  return !!navigator.userAgent.match(/MicroMessenger/i)
}

/**
 * 判断是否是iframe嵌套环境
 * @returns 是否是iframe嵌套环境
 */
export function isIframeClient() {
  return window !== window.parent
}

/**
 * iframe子级给顶级页面发送消息
 */
export function iframePostMessage(data: messageParam) {
  window.top && window.top.postMessage(data, '*')
}

export const isIOS = /iphone|ipad/i.test(navigator.userAgent)

/**
 * scheme跳转时，判断是否安装微信或支付宝；
 * 如果跳转成功则不会调用这段代码，如果失败则会调用
 * @param type wx，ali
 * @returns
 */
export function isInstallApp(type: string) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const result = {
        code: 40000,
        msg: `请安装${type === 'wx' ? '微信' : '支付宝'}客户端`
      }
      console.log(result)
      resolve(result)
    }, 5000)
  })
}

// 拼接参数
function joint(type: string, data = {}) {
  return Object.assign({ UniqueKey: type }, data);
}

// 是否hybrid环境
const isHybrid = window.location.protocol.indexOf("http") === -1;

const urlConfig = () => {
  // 兼容三方
  let baseUrl = 'https://webapps.yongjinbao.com.cn';
  if((window.location.href.indexOf('fzwebapps.yjbtest.com') !== -1)
    ||(window.location.href.indexOf('gjzq-test.jravity.com') !== -1)) {
    baseUrl = 'https://fzwebapps.yjbtest.com';
  }
 
  if(isHybrid){
    let env = (window as any).envConfig?.PORTAL_FINDER_ENV || (window as any).SHARE_ENV || 'prod';
    if(env && env !== 'prod') {
      baseUrl = 'https://fzwebapps.yjbtest.com';
    }
  }
  return {
    url: baseUrl + "/yjbwebservice/core/api",
    urlPost: baseUrl + "/yjbwebservice/core/api/json"
  }
};

// /yjbapi/shortlink/create
// serviceName.shortlink.create.remainParam
// 获取短链 区别于其他短链服务，保留参数
function getShortLinkFunc(data: any) {
  return http.post(urlConfig().urlPost, joint('serviceName.shortlink.create.remainParam', data))
}

/**
 * 获取短链
 */
export const getShortLink = async (url: string | undefined) => {
  if(!url) return null;
  let res = await getShortLinkFunc({
    origin_link: url || window.location.href,
    minute_to_alive: 365 * 24 * 60
  })
  console.log('短链：', res)
  if (res.code === 0) {
    if (res.result.indexOf('https://') !== -1 ||
      res.result.indexOf('http://') !== -1) {
      return res.result;
    }
  }
  return url;
}

const rEnv = /^https?:\/\/(dev|fz|localhost)/;

const match = rEnv.exec(location.href);

export const envStr: string = match ? (match[1] == 'localhost' ? 'local' : match[1]) : 'prod';

// 环境判断
export function getEnvStr() {
  let env: string = envStr;
  
  if(isHybrid) {
    env = (window as any).envConfig?.PORTAL_FINDER_ENV || (window as any).H5_COMMON_ENV || envStr || 'prod';
  }

  return env;
}